import { createAction, props } from '@ngrx/store';
import { ITag } from '../model/tag.model';

export const createTag = createAction('[Tags] Sending tag request', props<{ tag: ITag }>());
export const createTagSuccess = createAction('[Tags] Tag request sent successfully', props<{ tag: ITag }>());
export const createTagFailure = createAction('[Tags] Tag request sent with errors', props<{ error: string }>());

export const getTags = createAction('[Tags] Get all tags');
export const getTagsSuccess = createAction('[Tags] Get all tags success', props<{ tags: ITag[] }>());

export const editTag = createAction('[Tags] Edit tag request', (tag: ITag) => ({ tag }));
export const editTagSuccess = createAction('[Tags] Edit tag request successfully', props<{ tag: ITag }>());
export const editTagFailure = createAction('[Tags] Edit tag request with errors', props<{ error: string }>());

export const deleteTag = createAction('[Tags] Delete tag request', (tagId: string) => ({ tagId }));
export const deleteTagSuccess = createAction('[Tags] Delete tag request successfully', props<{ tag: ITag }>());
export const deleteTagFailure = createAction('[Tags] Delete tag request with errors', props<{ error: string }>());

export const tagsActions = {
    createTag,
    createTagSuccess,
    createTagFailure,
    getTags,
    getTagsSuccess,
    deleteTag,
    deleteTagSuccess,
    deleteTagFailure,
    editTag,
    editTagSuccess,
    editTagFailure
}